<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="container">
    <!-- 地图层级 -->
    <div class="map-box">
      <div class="plot-map">
        <centerMap></centerMap>
      </div>
    </div>
    <!-- 光效层级 -->
    <div class="Mask-box"></div>
    <!-- 数据展示层级 -->
    <div class="data-box-top">
      <div class="title">鑫农号智慧农业大屏</div>
      <div class="topbtn">
        <div class="btn btn1 active" @click="handleJumpTo('/')">首页</div>
        <div class="btn btn2" @click="handleJumpTo('/agriculturalPlan')">农事方案</div>
        <div class="btn btn3" @click="handleJumpTo('/agriculturalMachinery')">农机调度</div>
        <div class="btn btn4" @click="handleJumpTo('/deviceDetection')">设备检测</div>
      </div>
    </div>
    <div class="data-box">
      <div class="data-center">
      </div>
    </div>
    <div class="data-box-left">
      <div class="module">
        <div class="module-title">服务聚合</div>
        <div class="module-box">
          <div class="backgroundImage">
            <div class="module-li-1">
              <p class="title1">种植户入驻</p>
              <p class="name1">3000户</p>
            </div>
            <div class="module-li-2">
              <p class="title1">供应商入驻</p>
              <p class="name1">1000家</p>
            </div>
            <div class="module-li-3">
              <p class="title1">品牌农资</p>
              <p class="name1">2564种</p>
            </div>
            <div class="module-li-4">
              <p class="title1">农事服务</p>
              <p class="name1">85项</p>
            </div>
            <img src="@/assets/login.png" alt="" class="login">
          </div>
        </div>
      </div>
      <div class="module">
        <div class="module-title">交易占比</div>
        <div class="module-box">
          <EchartsFrom />
        </div>
      </div>
      <div class="module">
        <div class="module-title">农机分布</div>
        <div class="module-box">
          <hotMap></hotMap>
        </div>
      </div>
    </div>
    <div class="data-box-center">
      <div class="topMap">
        <!-- <centerMap></centerMap> -->
        <div class="center-statistics">
          <div class="statistics-li">
            <p class="statistics-li-title">平台总交易额</p>
            <p class="statistics-li-num"><span class="number">1000</span>万元</p>
          </div>
          <div class="statistics-li">
            <p class="statistics-li-title">累计服务农户数</p>
            <p class="statistics-li-num"><span class="number">3000</span>户</p>
          </div>
          <div class="statistics-li">
            <p class="statistics-li-title">合作机构数量</p>
            <p class="statistics-li-num"><span class="number">1000+</span>家</p>
          </div>
        </div>
      </div>
      <div class="selldata">
        <sellData></sellData>
      </div>
    </div>
    <div class="data-box-right">
      <div class="module">
        <div class="module-title">金融助农</div>
        <div class="module-box">
          <div class="jin-rong-box mar-rig">
            <div class="jin-rong-title">
              <img src="@/assets/amount_money.png" alt="" class="icon">
              <p class="text">累计发放贷款总额</p>
            </div>
            <p class="jin-rong-content">
              <span class="number">12800</span>
              万元
            </p>
          </div>
          <div class="jin-rong-box mar-left">
            <div class="jin-rong-title">
              <img src="@/assets/year_money.png" alt="" class="icon">
              <p class="text">年度新增贷款额</p>
            </div>
            <p class="jin-rong-content">
              <span class="number">3650</span>
              万元
            </p>
          </div>
          <div class="jin-rong-box mar-rig">
            <div class="jin-rong-title">
              <img src="@/assets/total_number.png" alt="" class="icon">
              <p class="text">受益农业主体总数</p>
            </div>
            <p class="jin-rong-content">
              <span class="number">1862</span>
              家
            </p>
          </div>
          <div class="jin-rong-box mar-left">
            <div class="jin-rong-title">
              <img src="@/assets/coverage_rate.png" alt="" class="icon">
              <p class="text">县域覆盖率</p>
            </div>
            <p class="jin-rong-content">
              <span class="number">12</span>
              县
            </p>
          </div>
        </div>
      </div>
      <div class="module">
        <div class="module-title">农险保障</div>
        <div class="module-box">
          <!-- <dv-scroll-board :config="config2" style="width: 100%" class="guarantee-ul" /> -->
          <dv-scroll-ranking-board :config="Settled3" class="guarantee-ul" />
        </div>
      </div>
      <div class="module">
        <div class="module-title">供应商入驻</div>
        <div class="module-box">
          <dv-scroll-board :config="Settled2" style="width: 100%" class="guarantee-ul" />
        </div>
      </div>
    </div>
    <!-- 农事记录 -->
    <workRecords v-if="showRecords" @close="showRecords = false"></workRecords>
    <!-- 地块信息 -->
    <landInfo @close="showLnad =false" v-if="showLnad" @openRecords="showRecords = true"></landInfo>
     <!-- 作物信息 -->
    <plantInfo v-if="showPlant" @close="showPlant = false"></plantInfo>
  </div>
</template>
<script setup>
import plantInfo from './components/plantInfo.vue';
import landInfo from './components/landInfo.vue';
import workRecords from './components/workRecords.vue'
import hotMap from './components/hotmap.vue'; // 农机分布-热力图
import EchartsFrom from './components/PieChart02'; // 交易占比-饼图
import sellData  from './components/sellData.vue'; // 平台销售数据-折线图
import centerMap from './components/centerMapThree.vue'; // 

import { reactive, onMounted ,ref} from "vue";
// import {useRouter} from 'vue-router'
// const router = useRouter()
import router from "@/router";

const showLnad = ref(false);
const showRecords = ref(true);
const showPlant = ref(false);
const config = reactive({
  data: [
    {
      name: '南阳',
      title: 92
    },
    {
      name: '郑州',
      title: 86
    },
    {
      name: '开封',
      title: 83
    },
    {
      name: '新乡',
      title: 79
    },
    {
      name: '洛阳',
      title: 78
    },
    {
      name: '鹤壁',
      title: 75.6
    },
    {
      name: '商丘',
      title: 73.5
    },
    {
      name: '安阳市',
      title: 73.2
    },
  ]
})
const config2 = reactive({
  data: [],
  align: ["center"],
  oddRowBGC: "",
  evenRowBGC: "",
  waitTime: 50000,
  rowNum: 4,
});

const Settled = reactive({
  data: [
    {
      name: '河南南阳农信通信息科技有限公司',
      time: '2025-05-01'
    },
    {
      name: '河南郑州农信通信息科技有限公司',
      time: '2025-06-03'
    },
    {
      name: '河南开封农信通信息科技有限公司',
      time: '2025-07-05'
    },
    {
      name: '新乡公司',
      time: '2025-08-07'
    },
    {
      name: '洛阳公司',
      time: '2025-09-09'
    },
    {
      name: '鹤壁公司',
      time: '2025-10-11'
    },
    {
      name: '商丘公司',
      time: '2025-11-13'
    },
    {
      name: '安阳市公司',
      time: '2025-12-15'
    },
  ]
})
const Settled2 = reactive({
  data: [],
  align: ["center"],
  oddRowBGC: "",
  evenRowBGC: "",
  waitTime: 30000,
  rowNum: 4,
});

const Settled3 = reactive({
  data: [
    {
      name: '周口',
      value: 10200
    },
    {
      name: '南阳',
      value: 10600
    },
    {
      name: '西峡',
      value: 12500
    },
    {
      name: '驻马店',
      value: 13000
    },
    {
      name: '新乡',
      value: 15000
    },
    {
      name: '鹤壁',
      value: 11500
    },
    {
      name: '开封',
      value: 13600
    },
  ],
  rowNum: 4, // 表行数
  waitTime: 3000, // 轮播时间间隔(ms)
  carousel: 'single', //	轮播方式
  unit: '亩',
  sort: true, // 自动排序
  textColor: '#ffffff', // 文字颜色
  color: '#1DEF8D', // 进度条颜色
  // colors: ['#e062ae', '#fb7293', '#e690d1', '#32c5e9', '#96bfff'],
  // valueFormatter:({ name, value, percent, ranking }) => {
  //   // 打印数值
  //   // console.warn(arguments)
  //   // 处理数字分隔
  //   const reverseNumber = (value + '').split('')
  //   let valueStr = ''
  //   while (reverseNumber.length) {
  //     const seg = reverseNumber.splice(0, 3).join('')
  //     valueStr += seg
  //     if (seg.length === 3) valueStr += ','
  //   }
  //   // 清除最后一个逗号问题
  //   if (valueStr[valueStr.length - 1] == ',')
  //     return valueStr.toString().slice(0, -1) + '(次数)'
  //     console.log('valueStr', valueStr)
  //   // 最后一位不是逗号，不用处理
  //   return valueStr + '(次数)'
  // }
});
onMounted(() => {
  newPrice()
  getSettled()
})

// 农险保障
const newPrice = (data) => {
  config2.data = [];
  config.data.forEach((item, i) => {
    config2.data.push([
      ` <div class="guarantee-li">
          <div class="guarantee-title">
            <div class="guarantee-left">
              <img src="${require("@/assets/lefticon" + (i % 4) + ".png")}" class="icon" />
              <p class="index">${i + 1}</p>
              <p class="text">县域覆盖率</p>
            </div>
            <p class="guarantee-right">${item.title}万亩</p>
          </div>
          <el-progress :percentage="${item.title}" status="success" class="guarantee-progress" />
        </div>`
    ]);
  });
};

// 供应商入住
const getSettled = () => {
  Settled2.data = [];
  Settled.data.forEach((item, i) => {
    Settled2.data.push([
      ` <div class="Settled-li">
          <div class="Settled-name">
            <p class="corporate-name">${ item.name }</p>
            <span class="Settled-type">已入驻</span>
          </div>
          <p class="Settled-time">${ item.time }</p>
        </div>`
    ]);
  });
}

// 跳转页面
const handleJumpTo = (path) => {
  router.push(path)
}
</script>
<style scoped lang="scss">

.container {
  width: 100%;
  height: 100vh;
  // background-image: url("@/assets/bg.png");
  // background-size: 100% 100%;
  // background-position: center;
  @font-face {
    font-family: "YouSheBiaoTiHei";
    src: url("@/fonts/YouSheBiaoTiHei-2.ttf") format("truetype"); /* 全局字体 */
    font-weight: normal;
    font-style: normal;
  }
  
  .map-box {
    width: 100vw;
    height: 100vh;
    position: absolute;
    top: 0vh;
    left: 0px;
    z-index: 1;
    .plot-map {
      width: 100%;
      height: 100%;
    }
    .province-city-district {
      width: 50%;
      height: 83vh;
    }
  }
  .Mask-box {
    width: 100%;
    height: 100vh;
    // background-image: radial-gradient(circle, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0) 25%, rgba(8, 40, 19, 0.4) 40%, rgba(8, 40, 19, 1) 100%);
    background-image: radial-gradient(circle, rgba(8, 40, 19, 0) 0%,rgba(8, 40, 19, 0.5) 40%, rgba(8, 40, 19, 1) 100%);
    background-position: center;
    background-repeat: no-repeat;
    position: fixed;
    top: 0px;
    left: 0%;
    z-index: 9;
    pointer-events: none;
  }
  .data-box-top {
    width: 100%;
    height: 12vh;
    position: fixed;
    z-index: 101;
    top: 0px;
    left: 0px;
    pointer-events: auto;
    .title {
      line-height: 7.5vh;
      font-family: YouSheBiaoTiHei;
      font-size: 44px;
      color: #f8fcff;
      letter-spacing: 6px;
      text-shadow: 0px 4px 1px rgba(19, 143, 46, 0.66);
      text-align: center;
    }
    .topbtn {
      width: 100%;
      height: 80px;
      position: fixed;
      top: 32px;
      left: 0;
      // border: 1px solid red;
      .btn {
        width: 245px;
        height:56.6px;
        object-fit: cover;
        line-height: 56.6px;
        text-align: center;
        
        background-size: contain;
        font-size: 22px;
        color: #fff;
        position: absolute;
        padding-right: 27px;
        box-sizing: border-box;
        cursor: pointer;
      }
      .btn1 {
        top: 0px;
        left: 175px;
        background-image: url("@/assets/left-title2-bg.png");
      }
      .btn2 {
        top: 24px;
        left: 390px;
        background-image: url("@/assets/left-title2-bg.png");
      }
      .btn3 {
        top: 0px;
        right: 175px;
        padding-left: 50px;
        background-image: url("@/assets/right-title2-bg.png");
      }
      .btn4 {
        top: 24px;
        right: 390px;
        padding-left: 50px;
        background-image: url("@/assets/right-title2-bg.png");
      }
      .active{
        background-image: url("@/assets/left-title-bg.png");
      }
    }
  }
  .data-box {
    width: 100%;
    height: 100vh;
    background-image: url("@/assets/background-img.png");
    background-size: 100% 100%;
    background-position: center;
    position: fixed;
    left: 0px;
    top: 0px;
    z-index: 99;
    pointer-events: none;
    // .data-center {
    //   width: 100%;
    //   height: 83vh;
    //   display: flex;
    //   justify-content: center;
    //   align-items: flex-start;
    // }
  }
  .data-box-left {
    width: 23%;
    height: 83vh;
    position: fixed;
    left: 2%;
    top: 11vh;
    z-index: 109;
    pointer-events: auto;
  }
  .data-box-center {
    width: 50%;
    height: 83vh;
    position: fixed;
    left: 25%;
    top: 11vh;
    z-index: 109;
    pointer-events: none;
    .topMap {
      height: calc(64% + 20px);
      width: 100%;
      position: relative;
    }
    .selldata {
      width: 100%;
      height: 33%;
      z-index: 9999;
    }
  }
  .data-box-right {
    width: 23%;
    height: 83vh;
    position: fixed;
    right: 2%;
    top: 11vh;
    z-index: 109;
    pointer-events: auto;
  }
  .data-box-left, .data-box-right {
    .module {
      width: 100%;
      height: 32%;
      margin-bottom: 10px;
      .module-title {
        width: 100%;
        height: 40px;
        font-weight: normal;
        font-size: 20px;
        color: #F6FEF8;
        text-shadow: 0px 0px 7px rgba(75,180,229,0.25), 0px 2px 8px rgba(5,28,55,0.42);
        text-align: left;
        background-image: url("@/assets/min-bg.png");
        background-size: 100% 100%;
        background-position: center;
        font-family: YouSheBiaoTiHei;
        padding-left: 35px;
      }
      .module-box {
        width: 100%;
        height: calc(100% - 40px);
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-flow: wrap;
        position: relative;
        .login {
          width: 4.8vw;
          height: 4.8vw;
          position: absolute;
          top: 50%;
          left: 50%;
          margin-top: -2.4vw;
          margin-left: -2.4vw;
        }
        .jin-rong-box {
          width: 45%;
          height: calc(50% - 10px);
          background-image: url("@/assets/finance.png");
          background-size: 100% 100%;
          background-position: center;
          .jin-rong-title {
            width: 100%;
            height: 37.5%;
            padding: 0px 16px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            .icon {
              width: 20px;
              height: auto;
            }
            .text {
              font-size: 14px;
              color: #FFFFFF;
              margin-left: 10px;
            }
          }
          .jin-rong-content {
            font-size: 14px;
            color: #FFFFFF;
            text-align: center;
            height: 62.5%;
            line-height: 62.5%;
            display: flex;
            justify-content: center;
            align-items: center;
            .number {
              font-weight: bold;
              font-size: 26px;
            }
          }
        }
      }
    }
  }
}

.guarantee-ul {
  width: 100%;
  height: 100%;
}

.backgroundImage {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-flow: wrap;
  position: relative;
  background-image: url("@/assets/Group_service.png");
  background-size: 100% auto;
  background-position: center;
  background-repeat: no-repeat;
  height: calc(11vw - 4px) !important;
  .module-li-1, .module-li-2, .module-li-3, .module-li-4 {
    width: 50%;
    height: calc(50% - 10px);
    color: #FFFFFF;
    display: flex;
    flex-direction: column;
    justify-content: center;
    // flex-flow: wrap;
    .title1 {
      width: 100%;
      font-size: 14px;
      line-height: 24px;
    }
    .name1 {
      width: 100%;
      font-weight: bold;
      font-size: 24px;
      line-height: 36px;
    }
  }
  .module-li-1, .module-li-3 {
    align-items: center;
    .title1, .name1  {
      padding: 0px 15px 0px 15px;
      text-align: left;
    }
  }
  .module-li-2, .module-li-4 {
    align-items: center;
    .title1, .name1  {
      padding: 0px 15px 0px 15px;
      text-align: right;
    }
  }
  .module-li-3, .module-li-4 {
    margin-top: 20px;
  }
}

.center-statistics {
  width: 100%;
  height: 120px;
  position: absolute;
  top: 0px;
  left: 0px;
  background-image: url("@/assets/center_statistics.png");
  background-size: 100% auto;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 0px 100px;
  .statistics-li {
    width: 33%;
    height: 120px;
    .statistics-li-title {
      font-size: 16px;
      color: #8CFFAF;
    }
    .statistics-li-num {
      font-size: 16px;
      color: #8BC6E4;
      .number {
        font-size: 32px;
        color: #E4F7EA;
      }
    }
  }
}
.mar-rig {
  margin-right: 5%;
}
.mar-left {
  margin-left: 5%;
}
</style>
<style lang="scss">
.guarantee-li {
  list-style: none;
  width: 100%;
  height: 55px;
  .guarantee-title {
    width: 100%;
    height: 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    color: #FFFFFF;
    line-height: 20px;
    .guarantee-left {
      width: 150px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      position: relative;
      .icon {
        width: 20px;
        height: 20px;
      }
      .index {
        position: absolute;
        top: 0px;
        left: 3px;
        font-size: 14px;
      }
      .text {
        margin-left: 10px;
      }
    }
    .guarantee-right {
      width: 150px;
      text-align: right;
    }
  }
}
.guarantee-progress {
  width: 100%;
  height: 20px !important;
}
.Settled-li {
  width: calc(100% - 6px);
  height: 40px;
  background: rgba(38, 255, 136, 0.2);
  border-radius: 0px 0px 0px 0px;
  border-left: 3px solid #19CA3A;
  border-right: 3px solid #19CA3A;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px 20px;
  .Settled-name {
    width: calc(100% - 90px);
    height: 40px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .corporate-name {
      width: calc(100% - 50px);
      height: 40px;
      line-height: 40px;
      font-weight: bold;
      font-size: 14px;
      color: #4AFF86;
      white-space: nowrap;      /* 禁止换行 */
      overflow: hidden;         /* 隐藏溢出内容 */
      text-overflow: ellipsis;  /* 显示省略号 */
      text-align: left;
    }
    .Settled-type {
      font-weight: 400;
      color: #FFFFFF;
      margin-left: 10px;
    }
  }
  .Settled-time {
    width: 90px;
    height: 40px;
    line-height: 40px;
    font-weight: 400;
    font-size: 14px;
    color: #FFFFFF;
    text-align: right;
  }
}
</style>
